import type { ActivityItem } from './merge'
import { t } from '../../copy'

export type StatusTone = 'n' | 'a' | 'w' | 'g' | 'r'

export function statusTone(status: ActivityItem['status']): StatusTone {
  switch (status) {
    case 'queued':
    case 'recovering':
      return 'n'
    case 'running':
      return 'a'
    case 'completed':
    case 'production_verified':
      return 'g'
    case 'failed':
      return 'r'
    default:
      return 'w'
  }
}

export function statusCopyId(status: ActivityItem['status']) {
  switch (status) {
    case 'queued':
      return 'activity.status.queued' as const
    case 'running':
      return 'activity.status.running' as const
    case 'awaiting_decision':
      return 'activity.status.awaiting_decision' as const
    case 'awaiting_dependency':
      return 'activity.status.awaiting_dependency' as const
    case 'platform_held':
      return 'activity.status.platform_held' as const
    case 'disconnected':
      return 'activity.status.disconnected' as const
    case 'recovering':
      return 'activity.status.recovering' as const
    case 'completed':
      return 'activity.status.completed' as const
    case 'production_verified':
      return 'activity.status.production_verified' as const
    case 'failed':
      return 'activity.status.failed' as const
    case 'rolled_back':
      return 'activity.status.rolled_back' as const
    default:
      return 'activity.status.unknown' as const
  }
}

export function statusText(status: ActivityItem['status'], rollbackLabel?: string): string {
  if (status === 'rolled_back' && rollbackLabel) return rollbackLabel
  return t(statusCopyId(status))
}
